export default class Roles {
    static SUPERADMIN = 'superadmin'
    static ADMIN = 'admin'
}



// WEBPACK FOOTER //
// ./src/helpers/roles.js